module.exports = __webpack_public_path__ + "static/03-ed570df480f3acd6e3478eb5cf272b45.png";